/* eslint-disable */
export const _mtm = typeof window !== 'undefined' && (window._mtm = window._mtm || [])
export default function matomoTagManagerPlugin(config) {
  return {
    initialize: () => {
      if (window.mtm_initialized) return
      _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' })
      ;(function () {
        const u = config.url
        const c = config.container
        const d = document
        const g = d.createElement('script')
        const s = d.getElementsByTagName('script')[0]
        g.type = 'text/javascript'
        g.async = true
        g.src = `${u}js/container_${c}.js`
        s.parentNode.insertBefore(g, s)
        window.mtm_initialized = true
      })()
    },
    name: 'matomoTagManager',
    page: ({ payload }) => {
      _mtm.push({ event: 'mtm.PageView', ...payload.properties })
    },
    track: ({ payload }) => {
      _mtm.push({ event: payload.event, ...payload.properties })
    },
  }
}
